import React from "react";

export const ProgressSuggestion = ({option, onClick}) => {
    return (
        <div
            className={'suggested-time-option'}
            onMouseDown={onClick.bind(this, option)}
        >
            <>
                {option + '%'}
            </>
        </div>
    )
}